export default "__VITE_ASSET__O572JKqW__"